import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { getProductCartQuantity } from "../../helpers/product";
import { addToCart, bulkAddToCart } from "../../redux/actions/cartActions";
import { addToWishlist } from "../../redux/actions/wishlistActions";
import { addToCompare } from "../../redux/actions/compareActions";
import { Rate, Select, Button, notification, Divider, Row } from "antd";
import confirm from "antd/lib/modal/confirm";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import "./newStyle.css";
import { DropdownInput } from "./DropdownInput";
import ImageRowVarient from "./ImageRowVarient";
import DropDownVarient from "./DropDownVarient";
import RectangleListVarient from "./RectangleListVarient";
import RadioButtonVarient from "./RadioButtonVariant";
import {
  ProductVariantDisplayType,
  Units,
} from "../../pages/constant/Constants";
import { isEmpty, isEqual } from "lodash";
import DetailListVarient from "./DetailListVariant";
import { isProductTobaccoEligible, getImagesForImageDisplay, refModal, tobaccoEligibilityMessage, formatCurrency } from "../../pages/constant/utils";
import PromotionsPrice from "../common/PromotionPrice";
import PromotionsQTY from "../common/PromotionQTY";
import PromotionsTimer from "../common/PromotionTimer";
import GridViewVariant from "./GridViewVariant";

const ProductDescriptionInfo = ({
  selectedVariant,
  setSelectedVariant,
  product,
  discountedPrice,
  currency,
  finalDiscountedPrice,
  finalProductPrice,
  cartItems,
  wishlistItem,
  compareItem,
  addToast,
  addToCart,
  bulkAddToCart,
  addToWishlist,
  addToCompare,
  settingData,
  themeSettingData,
  userData,
  userDetail,
  setCombineSelectedImage,
}) => {
  const {
    price_display_for_secure_user,
    price_display_for_unsecure_user,
    stock_display_for_secure_user,
    stock_display_for_unsecure_user,
  } = themeSettingData || {};
  
  const variantUpc = !selectedVariant?.selected_unit_price?.upc  ? "" : `/ ${selectedVariant?.selected_unit_price?.upc}` 
  let modalRef = useRef(null);
  const history = useHistory();
  const licensePath = () => history.push('/profile/my-account')
  const [selectedProductColor] = useState(
    product.variation ? product.variation[0].color : ""
  );
  const [selectedProductSize] = useState(
    product.variation ? product.variation[0].size[0].name : ""
  );

  const [quantityCount, setQuantityCount] = useState("00");
  let [quantityCountObj, setQuantityCountObj] = useState({});
  const [variantValues, setVariantValues] = useState([])
  const [variantRadio, setVariantRadio] = useState([])
  const [variantDropdown, setVariantDropdown] = useState([])
  const [variantRectangle, setVariantRectangle] = useState([])
  const [variantList, setVariantList] = useState("")
  const [values, setValues] = useState(() => {
    const attributes = {};
    try {
      for (const attribute of product.product_variant_attribute) {
        // if (attribute.display_type != ProductVariantDisplayType.DETAILED_LIST.type ){
          attributes[attribute.ecom_name] = attribute.value;
        // }
        const displayTypeMapping = {
          [ProductVariantDisplayType.IMAGE.type]: setVariantValues,
          [ProductVariantDisplayType.DROP_DOWN.type]: setVariantDropdown,
          [ProductVariantDisplayType.RADIO_BUTTON.type]: setVariantRadio,
          [ProductVariantDisplayType.RECTANGLE_LIST.type]: setVariantRectangle,
        };
        
        const updateVariant = displayTypeMapping[attribute.display_type];
        if (updateVariant) {
          updateVariant(attribute.value);
        }
      }
      return attributes;
    } catch {
      return {};
    }
  });

  const productCartQty = getProductCartQuantity(
    cartItems,
    product,
    selectedProductColor,
    selectedProductSize
  );

  const [activeButton, setActiveButton] = useState(null); // Tracks the active button

  const handleClick = (buttonNumber) => {
    setActiveButton(buttonNumber); // Sets the active button
  };

  // Function to determine button style
  const getButtonStyle = (buttonNumber) => {
    return activeButton === buttonNumber ? "activeButtonSize" : "";
  };

  const [variantImages, setVariantImages] = useState({});
  const [variantsAttributes, setVariantsAttributes] = useState([]);
  const [isListVariant, setIsListVariant] = useState(false)

  const FindDisplayType = product.variant_attributes.find(
    ({ display_type }) =>
      display_type === ProductVariantDisplayType.DETAILED_LIST.type || 
      display_type === ProductVariantDisplayType.GRID_VIEW.type
  );
  useEffect(() => {
    if (FindDisplayType) {
      setIsListVariant(true);
    }
  }, [product.variant_attributes]);

  const [isDisabled, setIsDisabled] = useState(false);
  
    useEffect(() => {
      if (
        !product.back_order_ecom &&
        (["", 0, null].includes(quantityCount) ||
          productCartQty + Number(quantityCount) > product.saleable_qty)
      ) {
        setIsDisabled(true);
      } else {
        setIsDisabled(false);
      }
    }, [quantityCount, productCartQty, product]);
    
  const attributeFun = (product) => {
    const result = {};

    const variantDisplayTypeImages = getImagesForImageDisplay(product);

    setVariantImages(variantDisplayTypeImages);

    product.variant_attributes.forEach((item) => {
      const { ecom_name, value, display_type, attachment, attachment_name } = item;
      if (!result[ecom_name]) {
        
        if (display_type == ProductVariantDisplayType.IMAGE.type && ProductVariantDisplayType.DETAILED_LIST.type &&ProductVariantDisplayType.RADIO_BUTTON.type) {
          result[ecom_name] = {
            name: ecom_name,
            value: [],
            display_type,
            attachment,
            attachment_name
          };
        } else {
          result[ecom_name] = {
            name: ecom_name,
            value: [],
            display_type,
            attachment,
            attachment_name
          };
        }
      }
      if (!result[ecom_name].value.includes(value)) {
        result[ecom_name].value.push(value);
      }
    });
    let tempResult = Object.values(result);
    tempResult = tempResult.sort((a, b) => a.display_type - b.display_type);
    const displayTypes = new Set();
    const uniqueTempResult = tempResult.filter(item => {
      if (displayTypes.has(item.display_type)) {
        return false;
      }
      displayTypes.add(item.display_type);
      return true;
    });

    return uniqueTempResult;
  };

  useEffect(() => {
    const attributes = attributeFun(product)
    const displayTypeGrid = attributes.find(({display_type})=>display_type == 6)
    if (displayTypeGrid){
      setVariantsAttributes([displayTypeGrid]);
    }else{
      setVariantsAttributes(attributes);
    }
  }, [product]);

  function findProductByAttributes(attributesToFind, product) {
    const { variant_product, product_variant_attribute } = product;
    if (!variant_product?.length) {
      return product;
    }
    // matching attribute in default variant
    const attributes = {};
    for (const attribute of product_variant_attribute) {
      attributes[attribute.ecom_name] = attribute.value;
    }
    if (isEqual(attributes, attributesToFind)) {
      return product;
    }
    // end

    for (const variant of variant_product) {
      const { product_variant_attribute } = variant;
      const attributes = {};

      for (const attribute of product_variant_attribute) {
        attributes[attribute.ecom_name] = attribute.value;
      }

      // Compare the attributes of the current product with the attributes to find
      if (isEqual(attributes, attributesToFind)) {
        return variant;
      }
    }
    return null; // Return null if no matching product is found
  }

  useEffect(() => {
    setSelectedVariant(findProductByAttributes(values, product));
  }, [values]);

  let productNameSkuSection = (
    <>
      {selectedVariant?.variant_attributes?.length !== 0 ? (
        <>
          {!variantsAttributes.find(({ display_type }) => display_type == ProductVariantDisplayType.DETAILED_LIST.type) ?
            <>
              <label
                style={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
              >
                {selectedVariant?.ecom_name || selectedVariant?.name}
              </label>

              <Row style={{ margin: "0px" }}>
                {/* <div className="frame-4-sku"> */}
                <div style={{alignContent:"center"}}>
                <div className="text-wrapper-3-sku">
                    {themeSettingData?.sku_display_on_product_detail === true && (selectedVariant?.sku || product?.sku) ?
                      `${selectedVariant?.sku || product?.sku}` + 
                      (themeSettingData?.upc_display_on_product_detail === true && (variantUpc || product?.upc) ? `${variantUpc}` : '')
                      : (themeSettingData?.upc_display_on_product_detail === true && (variantUpc || product?.upc) ? `${variantUpc || product?.upc}` : '')
                    }
                  </div>
                </div>
                {(!userDetail?.user &&
                  themeSettingData?.stock_display_for_unsecure_user) ||
                  (themeSettingData?.stock_display_for_secure_user && userDetail?.user) ? (
                  <>
                    <div
                      className="frame-5-sku"
                      style={{
                        background: selectedVariant?.back_order_ecom
                          ? "#FDFAEB"
                          : selectedVariant?.saleable_qty <= 0
                            ? "#FFE7E5"
                            : "#EFEDF8",
                        // background:
                        //   selectedVariant?.saleable_qty <= 0 ||
                        //   selectedVariant?.back_order_ecom
                        //     ? "#FFE7E5"
                        //     : "#EFEDF8",
                        marginLeft: "5px",
                      }}
                    >
                      <div
                        className="text-wrapper-4-sku"
                        style={{
                          color: selectedVariant?.back_order_ecom
                            ? "#EFD138"
                            : selectedVariant?.saleable_qty <= 0
                              ? "#FB1100"
                              : "#5F4BB6",
                        }}
                      >
                        {selectedVariant?.back_order_ecom
                          ? "Low Stock"
                          : selectedVariant?.saleable_qty <= 0
                            ? "Out of Stock"
                            : `Qty: ${selectedVariant?.saleable_qty ??
                            (product?.saleable_qty || 0)
                            }`}
                      </div>
                    </div>
                  </>
                ) : null}
              </Row>
              {(selectedVariant?.certificate_of_analysis) && (
                      <p className="coa-style"
                      style={{fontSize:"14px", fontWeight:"400"}}
                        onClick={() => {
                          const url = selectedVariant.certificate_of_analysis
                          if (url) {
                            window.open(url, '_blank');
                          } else {
                            console.error('Certificate of Analysis not available.');
                          }
                        }}
                      >
                        Specs & COA
                      </p>
                    )}
            </>
            : null}
          <Divider style={{ margin: "10px 0px" }} />
        </>
      ) : null}
    </>
  );

  const conditionalComponent = (variant_attribute, key = 0, length = 0) => {
    const { display_type, value, name } = variant_attribute;
    switch (display_type) {
      // case ProductVariantDisplayType.type:
      //     return <ScrollListVarient product={product} />;
      case ProductVariantDisplayType.IMAGE.type:
        return (
          <>
            <ImageRowVarient
              variant_attribute={variant_attribute}
              setCombineSelectedImage={setCombineSelectedImage}
              setValues={setValues}
              values={values}
              selectedVariant={selectedVariant}
              variantImages={variantImages}
              setVariantValues={setVariantValues}
              settingData={settingData}
              FindDisplayType={FindDisplayType}
            />
            {length === 1 || (length > 1 && key === 0)
              ? productNameSkuSection
              : null}
          </>
        );
      case ProductVariantDisplayType.DROP_DOWN.type:
        return (
          <>
            <DropDownVarient
              variant_attribute={variant_attribute}
              setValues={setValues}
              values={values}
              selectedVariant={selectedVariant}
              product={product}
              setVariantDropdown={setVariantDropdown}
              FindDisplayType={FindDisplayType}
            />
            {length === 1 || (length > 1 && key === 0)
              ? productNameSkuSection
              : null}
          </>
        );
      case ProductVariantDisplayType.RECTANGLE_LIST.type:
        return (
          <>
            <RectangleListVarient
              variant_attribute={variant_attribute}
              setValues={setValues}
              values={values}
              selectedVariant={selectedVariant}
              product={product}
              setVariantRectangle={setVariantRectangle}
              FindDisplayType={FindDisplayType}
            />
            {length === 1 || (length > 1 && key === 0)
              ? productNameSkuSection
              : null}
          </>
        );
      case ProductVariantDisplayType.RADIO_BUTTON.type:
        return (
          <>
            <RadioButtonVarient
              variant_attribute={variant_attribute}
              setVariantRadio={setVariantRadio}
              setValues={setValues}
              values={values}
              selectedVariant={selectedVariant}
              product={product}
              FindDisplayType={FindDisplayType}
            />
            {length === 1 || (length > 1 && key === 0)
              ? productNameSkuSection
              : null}
          </>
        );
      case ProductVariantDisplayType.DETAILED_LIST.type:
        let tempProducts = product.variant_product;
        tempProducts = [{ ...product, variant_product: null }, ...tempProducts];
        return (
          <DetailListVarient
            variant_attribute={variant_attribute}
            setValues={setValues}
            values={values}
            selectedVariant={selectedVariant}
            setSelectedVariant={setSelectedVariant}
            tempProducts={tempProducts}
            currency={currency}
            quantityCountObj={quantityCountObj}
            setQuantityCountObj={setQuantityCountObj}
            userDetail={userDetail}
            variantValues={variantValues}
            product={product}
            settingData={settingData}
            themeSettingData={themeSettingData}
            userData={userData}
            variantsAttributes={variantsAttributes}
            variantRadio={variantRadio}
            variantDropdown={variantDropdown}
            variantRectangle={variantRectangle}
            setVariantList={setVariantList}
          />
        );
        case ProductVariantDisplayType.GRID_VIEW.type:
        return (
          <GridViewVariant 
            variant_attribute={variant_attribute} 
            product={product} 
            settingData={settingData}
            themeSettingData={themeSettingData}
            currency={currency} 
            userDetail={userDetail}
            quantityCountObj={quantityCountObj}
            setQuantityCountObj={setQuantityCountObj} 
            setSelectedVariant={setSelectedVariant}
            selectedVariant={selectedVariant}
            userData={userData}
            modalRef={modalRef}
            licensePath={licensePath}
            />
        )
      default:
        return null; 
    }
  };
  const targetDate = new Date(product?.selected_unit_price?.promotion?.end_datetime).getTime();
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>Time's up!</span>;
    } else {
      return (
        <div>
          <p>Promotion ends in:</p>
          <span>{days} Days </span>
          <span>{hours} Hours </span>
          <span>{minutes} Minutes </span>
          <span>{seconds} Seconds</span>
        </div>
      );
    }
  };
  return (
    <div className="pro-frame">
      <div className="flex-display">
        <div className="div">
          {/* <div className="div-2">
          {!isListVariant && (
            <div className="div-wrapper">
              <div className="text-wrapper">Brand: {product.brand.name}</div>
            </div>
          )}
        </div> */}
          <h1 className="smoke-novo bg-warning">
            {/* {isListVariant ? product.group_name : product.name} */}
            {product?.group_name || product?.ecom_name || product?.name || ""}
          </h1>
          {(product?.certificate_of_analysis && product.variant_product.length == 0) && (
            <p className="coa-style"
              onClick={() => {
                const url = product.certificate_of_analysis;
                if (url) {
                  window.open(url, '_blank');
                } else {
                  console.error('Certificate of Analysis not available.');
                }
              }}
            >
              Specs & COA
            </p>
          )}

          <div style={{ display: "flex", alignItems: "baseline" }}>
            {product.variant_product.length <= 0 && (
              <div
                className="frame-4-sku"
              >
                <div className="text-wrapper-4">
                  {themeSettingData?.sku_display_on_product_detail === true && product?.sku &&
                    themeSettingData?.upc_display_on_product_detail === true && product?.selected_unit_price?.upc
                    ? `${product.sku} / ${product.selected_unit_price.upc}`
                    : themeSettingData?.sku_display_on_product_detail === true && product?.sku
                      ? product.sku
                      : themeSettingData?.upc_display_on_product_detail === true && product?.selected_unit_price?.upc
                        ? product.selected_unit_price.upc
                        : ''
                  }
                </div>
              </div>
            )}
            {(Array.isArray(selectedVariant?.product_variant_attribute) && selectedVariant.product_variant_attribute.length === 0 &&
              ((themeSettingData.stock_display_for_unsecure_user && !userDetail?.user) ||
                (themeSettingData.stock_display_for_secure_user && userDetail?.user))) && (
                <div
                  className="frame-5-sku"
                  style={{
                    background: product?.back_order_ecom
                      ? "#FDFAEB"
                      : product.saleable_qty <= 0
                        ? "#FFE7E5"
                        : "#EFEDF8",
                  }}
                >
                  <div
                    className="text-wrapper-4"
                    style={{
                      color: product?.back_order_ecom
                        ? "#EFD138"
                        : product?.saleable_qty <= 0
                          ? "#FB1100"
                          : "#5F4BB6",
                    }}
                  >
                    {product?.back_order_ecom
                      ? "Low Stock"
                      : product?.saleable_qty <= 0
                        ? "Out of Stock"
                        : `Qty: ${product.saleable_qty || 0}`}
                  </div>
                </div>
              )}

          </div>
          {!variantsAttributes.find(
          ({ display_type }) =>
            display_type == ProductVariantDisplayType.DETAILED_LIST.type || display_type == ProductVariantDisplayType.GRID_VIEW.type 
        ) ?
          <div className="div-12">
            {(!userDetail?.user &&
              themeSettingData?.price_display_for_unsecure_user) ||
              (themeSettingData?.price_display_for_secure_user && userDetail?.user) ? (
              <div className="text-wrapper-13">
                <PromotionsPrice  product={selectedVariant} regularprice={true} currency={currency.currency_symbol}/>
                {selectedVariant?.is_tax_inclusive && 
                <p className="tax-inclusive">Tax Inclusive</p>
                }
              </div>
            ) : null}
          </div>
          : null}
          <PromotionsTimer product={selectedVariant || product} heading={true} settings={currency}/>  

        </div>
        
      </div>
      <div className="unit-in-detail">
        {!isListVariant && (
          <>
            <label
              className="product-unit-detail"
            >
              Unit
            </label>
            <div className="small-field">
              <div className="component">
                <div className="text-wrapper-4">
                  {Units[selectedVariant?.selected_unit_price?.unit || 1].name}
                </div>
              </div>
            </div>
          </>
        )}

        <Divider style={{ margin: "10px 0px" }} />

        {variantsAttributes.map((el, key) => {
          return conditionalComponent(el, key, variantsAttributes?.length);
        })}
      </div>
      <div>
      </div>
      <div className="div-6">
        <div className="new-line" />
      </div>
      <div
        className="div-11"
        style={{ alignItems: "end", width: "100%", justifyContent: "end" }}
      >
        {!isListVariant && (
          <div className="frame-9">
            <div className="frame-10">
              <div className="text-wrapper-7">
              <PromotionsQTY selectedVariant={selectedVariant}/>
                <DropdownInput
                  incrementMainclass={"increment-detail-single"}
                  incrementSubClass={"increment-main-class"}
                  inputCardClass={"new-input-card"}
                  decrement={() =>
                    setQuantityCount(
                      Number(quantityCount) > 1 ? Number(quantityCount) - 1 : 1
                    )
                  }
                  increment={() => {
                    if (
                      isProductTobaccoEligible(selectedVariant, userData, settingData)
                    ) {
                      setQuantityCount(
                        !product.back_order_ecom
                          ? Number(quantityCount) < product.saleable_qty
                            ? Number(quantityCount) + 1
                            : Number(quantityCount)
                          : Number(quantityCount) + 1
                    );
                    } else {
                      refModal(modalRef, licensePath)
                    }
                  }}
                  value={quantityCount}
                  handleChange={({ target: { value } }) => {
                    const formattedValue = value.replace(/\D/g, "");
                    if (
                      !product.back_order_ecom &&
                      Number(formattedValue) > product.saleable_qty
                    ) {
                      notification.error({
                        message: "You can not add more than in stock quantity",
                      });
                      return;
                    }
                    setQuantityCount(formattedValue);
                  }}
                />
                
              </div>
            </div>
          </div>
        )}

        <div>
          {(!selectedVariant?.saleable_qty <= 0 && !isListVariant) || 
          (!isListVariant && product?.variant_product?.length == 0 && 
            product.saleable_qty && product.saleable_qty > 0) || 
            (product?.variant_product?.length > 0 && selectedVariant?.saleable_qty > 0 && !isListVariant) ||
            (product?.variant_product?.length == 0 && product?.back_order_ecom && !isListVariant) || 
            (product?.variant_product?.length > 0 && selectedVariant?.back_order_ecom && !isListVariant) ? (
            <button
              className="add-to-cart"
              onClick={() => {
                if (!userDetail?.user) {
                  addToast("Please login first to view the cart", {
                    appearance: "info",
                    autoDismissTimeout: 1000,
                    autoDismiss: true,
                  });
                }  else 
                if (isDisabled) {
                  notification.error({
                    message: "You can not add more than in stock quantity",
                  });
                  return;
                }
                if(product?.eligibility_check && !product?.eligibility_check?.is_eligible){
                  notification.error({message:`Sale of this ${product?.name} is not allowed due to ${product?.eligibility_check?.reasons}. Please upload the license in the 'Profile' section to make a purchase.`})
                   }
                else {
                  if (
                    isProductTobaccoEligible(product, userData, settingData)
                  ) {
                    addToCart(
                      findProductByAttributes(values, product),
                      addToast,
                      cartItems,
                      Number(quantityCount)
                    );
                   
                  } else {
                    refModal(modalRef, licensePath)
                  }
                }
              }}
            >
              {" "}
              Add To Cart{" "}
            </button>
          ) : (
            !isListVariant && (
              <button
                className="out-of-stock"
                disabled
              >
                Out of Stock
              </button>
            )
          )}

          {isListVariant && (
            <button
              className="add-to-cart"
              onClick={() => {
                if (!userDetail?.user) {
                  addToast("Please login first to view the cart", {
                    appearance: "info",
                    autoDismissTimeout: 1000,
                    autoDismiss: true,
                  });
                }else  if(product?.eligibility_check && !product?.eligibility_check?.is_eligible){
                  notification.error({message:`Sale of this ${product?.name} is not allowed due to ${product?.eligibility_check?.reasons}. Please upload the license in the 'Profile' section to make a purchase.`})
                } else {
                  if(
                    quantityCountObj &&
                    Object.keys(quantityCountObj).length > 0 &&
                    Object.values(quantityCountObj).every(value => value !== null)  ){
                  // if (
                  //   isProductTobaccoEligible(selectedVariant, userData, settingData)
                  // ) {
                    let quantityHavingKeys = Object.keys(
                      quantityCountObj
                    ).filter((qtyObj) => quantityCountObj[qtyObj] > 0);

                    let productItems = quantityHavingKeys.map((id) => {
                      return {
                        id: id * 1,
                        enterQuantity: quantityCountObj[id] * 1,
                      };
                    });

                    let getItems = cartItems.map((item) => {
                      let temp = productItems.findIndex(
                        (productItemEle) => productItemEle.id == item.id
                      );
                      if (temp != -1) {
                        let deletedItem = productItems.splice(temp, 1)[0];
                        return {
                          ...item,
                          quantity:
                            +deletedItem?.enterQuantity + +item.quantity,
                          enterQuantity: undefined,
                        };
                      } else {
                        return { ...item, enterQuantity: undefined };
                      }
                    });

                    let tempVariantProducts = [
                      { ...product, variant_product: null },
                      ...product.variant_product,
                    ];

                    productItems.map((proEle) => {
                      let findedPro = tempVariantProducts.find(
                        (tempVariantProductEle) =>
                          tempVariantProductEle.id == proEle.id
                      );
                      getItems.push({
                        ...findedPro,
                        quantity: proEle.enterQuantity * 1,
                        enterQuantity: undefined,
                      });
                    });

                    bulkAddToCart(getItems, addToast, () => {
                      setQuantityCountObj({});
                    });
                  // }
                  // else {
                  //   refModal(modalRef, licensePath);
                  // }
                }else{
                  notification.error({
                    message: "You can't add product with 0 quantity",
                });
                return;
                }
                }
              }}
            >
              Add To Cart
            </button>
          )}
        </div>
        {/* <div className="small-field">
          <div className="component" style={{ display: "none" }}>
            <div className="text-wrapper-4">Piece</div>
            
          </div>
        </div> */}
      </div>

      <div className="div-13"></div>
    </div>
  );
};

ProductDescriptionInfo.propTypes = {
  selectedVariant: PropTypes.object,
  setSelectedVariant: PropTypes.func,
  addToCart: PropTypes.func,
  addToCompare: PropTypes.func,
  addToWishlist: PropTypes.func,
  addToast: PropTypes.func,
  cartItems: PropTypes.array,
  userData: PropTypes.object,
  compareItem: PropTypes.array,
  currency: PropTypes.object,
  discountedPrice: PropTypes.number,
  finalDiscountedPrice: PropTypes.number,
  finalProductPrice: PropTypes.number,
  product: PropTypes.object,
  wishlistItem: PropTypes.object,
  settingData: PropTypes.object,
  userDetail: PropTypes.object,
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (item, addToast, cartItems,  quantityCount) => {
      dispatch(addToCart(item, addToast, cartItems, quantityCount));
    },
    bulkAddToCart: (items, addToast, additionalOperation) => {
      dispatch(bulkAddToCart(items, addToast, additionalOperation, "allItems"));
    },
    addToWishlist: (item, addToast) => {
      dispatch(addToWishlist(item, addToast));
    },
    addToCompare: (item, addToast) => {
      dispatch(addToCompare(item, addToast));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    settingData: state.settingData.ecom.basic,
    themeSettingData: state.settingData.ecom.theme,
    userData: state.userData.user,
    userDetail: state.userData,
    product: state.productData.detailProduct,
    currency:state.settingData?.["admin-panel"]?.basic||{},
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDescriptionInfo);
